import type { NodePropertyName } from '@salescore/core'
// eslint-disable-next-line sonarjs/deprecation
import { useModal } from '@salescore/frontend-common'
import { Input, Modal } from 'antd'
import { t } from 'i18next'

import { useGetModel } from '../../../../../recoil/view/selectors/connectionsSelector'
import { NodePropertyPickerContent } from './NodePropertyPickerContent'
import type { NodeWithModel } from './nodeWithModel'

export const NodePropertyPicker = ({
  propertiesWithNode,
  picked,
  onFinish,
}: {
  propertiesWithNode: NodeWithModel[]
  picked: NodePropertyName | undefined
  onFinish: (property: NodePropertyName) => void
}) => {
  // eslint-disable-next-line sonarjs/deprecation
  const modal = useModal()
  const getModel = useGetModel()

  const getPickedLabel = () => {
    if (picked === undefined) {
      return ''
    }
    const pickedModel = getModel(picked.modelName)
    const pickedPropertyWithNode = propertiesWithNode.find(
      (x) => x.model.name === picked.modelName && x.property.name === picked.propertyName,
    )
    if (pickedModel === undefined || pickedPropertyWithNode === undefined) {
      return ''
    }
    return `${pickedModel.label}: ${pickedPropertyWithNode.property.label}`
  }

  return (
    <>
      <Input.TextArea
        onClick={() => {
          modal.showModal()
        }}
        // eslint-disable-next-line sonarjs/todo-tag
        // TODO: node name
        value={getPickedLabel()}
        readOnly
        autoSize={{ minRows: 1, maxRows: 3 }}
      />
      <Modal
        open={modal.isModalVisible}
        onCancel={modal.hideModal}
        width={900}
        cancelText={t(`閉じる`)}
        okButtonProps={{ style: { display: 'none' } }}
        title={<div></div>}
        style={{ top: '3%' }}
        destroyOnHidden
      >
        <NodePropertyPickerContent
          showInternalName={false}
          propertiesWithNode={propertiesWithNode}
          onFinish={(nodePropertyName) => {
            onFinish(nodePropertyName)
            modal.hideModal()
          }}
        />
      </Modal>
    </>
  )
}
